import { resolvePlatformOrigin } from 'BomdisoftUtilities/shared-billing';

export type SharedLoginIntent = 'signin' | 'signup';

const PRODUCTION_AUTH_URL = 'https://auth.bomdisoft.com';

/**
 * Public origin of the shared Bomdisoft login. This carried the same silent
 * production fallback the hub URL did, which pointed local builds at the live
 * host; see resolvePlatformOrigin for why that is worse than a dead link.
 */
export const getSharedAuthUrl = (): string => resolvePlatformOrigin('NEXT_PUBLIC_BOMDISOFT_AUTH_URL', process.env.NEXT_PUBLIC_BOMDISOFT_AUTH_URL, PRODUCTION_AUTH_URL);

/**
 * Public origin of the Bomdisoft ID accounts console (profile, connected
 * products, data and deletion). A consumer that has not been told the console's
 * own origin follows the auth host's `/account`, which the login app answers
 * with a permanent redirect to the console, so the link never goes dark while
 * environments are being pointed at the new host one at a time.
 */
export const getSharedAccountsUrl = (): string => {
  const configured = process.env.NEXT_PUBLIC_BOMDISOFT_ACCOUNTS_URL;
  return configured ? configured.replace(/\/+$/, '') : `${getSharedAuthUrl()}/account`;
};

/**
 * Destination for a product's Sign in / Get started controls. Only the product KEY
 * travels in the URL: the shared login resolves it against its own server-side
 * registry, so a tampered value can never redirect a signed-in user off-platform.
 */
export const getSharedLoginUrl = (product: string, intent: SharedLoginIntent = 'signin'): string => {
  const path = intent === 'signup' ? '/login/signup' : '/login';
  return `${getSharedAuthUrl()}${path}?product=${encodeURIComponent(product)}`;
};
